import {FETCH_MAP_CITIES_REQUEST, FETCH_MAP_CITIES_SUCCES, FETCH_MAP_CITIES_ERROR} from '../constants/Map'
import { jsonGet, errorHandler } from '../utils/Request';

const loadMap = () => (dispatch) => {
  const apiUrl = '/cities/map/list/';
  dispatch({
    type: FETCH_MAP_CITIES_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_MAP_CITIES_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_MAP_CITIES_ERROR
      });
      errorHandler(e);
    });
};

export { loadMap };



// WEBPACK FOOTER //
// ./src/actions/MapActions.js